import { useQuery } from "@tanstack/react-query";
import { pathPickQueryApi } from "@/features/pathpick/api/query";
import { PathPickPoizonOptionsResponse } from "@/features/pathpick/types/response";
import { toCamelKeyObject } from "@/utils/case";

// 사이즈별 포이즌 시세 조회 훅 — 크림과 같은 이유로 목록에 싣지 않고 상세 진입 시점에 부른다.
// 봉투(market/productId/source/options)는 크림과 같고, 옵션마다 sales_30d 가 더 온다.
export const poizonOptionsQuery = (spuId: number | undefined) => ({
  queryKey: ["pathpick", "poizon-options", spuId],
  queryFn: async () => {
    const data = await pathPickQueryApi.getPoizonOptions(spuId as number);
    return toCamelKeyObject(data) as PathPickPoizonOptionsResponse;
  },
  // 서버도 5분 캐시라 그보다 짧게 잡을 이유가 없다.
  staleTime: 5 * 60 * 1000,
});

const useGetPoizonOptions = (spuId: number | undefined, enabled: boolean) => {
  const { data, isPending, isError } = useQuery({
    ...poizonOptionsQuery(spuId),
    enabled: enabled && Boolean(spuId),
  });

  return {
    poizonOptions: data?.options ?? [],
    // 수집 실패/시간 초과는 200 + 빈 배열 + source="unavailable" 이고,
    // 상품이 DB에 없으면 404 다 — 둘 다 "조회 실패"로 같이 다룬다.
    isPoizonUnavailable: data?.source === "unavailable" || isError,
    isPoizonOptionsPending: Boolean(spuId) && enabled && isPending,
  };
};

export default useGetPoizonOptions;
